import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboMetaObjetivoComponent } from './combo-meta-objetivo.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboMetaObjetivoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboMetaObjetivoComponent]
})
export class ComboMetaObjetivoModule { }
